import React from "react";
import { Card, Typography, Space, Button, Row, Col, Avatar } from "antd";
import { QRCode } from "antd";
import honghuiLogo from "../assets/images/honghui-logo.webp";

const { Title, Paragraph, Text, Link } = Typography;

const About: React.FC = () => {
  return (
    <div
      style={{
        background: "linear-gradient(145deg, #f6f8fc 0%, #eef2f7 100%)",
        minHeight: "100%",
        borderRadius: 8,
        padding: "16px",
      }}
    >
      {/* 头部标题卡片 */}
      <div>
        <Card
          variant="outlined"
          style={{
            borderRadius: 8,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            marginBottom: 16,
            overflow: "hidden",
          }}
          styles={{
            body: { padding: 0 },
          }}
        >
          <div
            style={{
              background: "linear-gradient(120deg, #0a5cff 0%, #45a6ff 100%)",
              padding: "40px 30px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* 背景装饰 */}
            <div
              style={{
                position: "absolute",
                right: -20,
                top: -20,
                opacity: 0.06,
                fontSize: 240,
                transform: "rotate(10deg)",
              }}
            >
              <i className="ri-code-ai-line" />
            </div>
            <div
              style={{
                position: "absolute",
                left: 30,
                bottom: -30,
                opacity: 0.04,
                fontSize: 120,
              }}
            >
              <i className="ri-bubble-chart-line" />
            </div>

            <Title
              level={1}
              style={{
                margin: 0,
                color: "white",
                display: "flex",
                alignItems: "center",
                fontSize: 34,
                fontWeight: 700,
              }}
            >
              <img 
                src={honghuiLogo}
                alt="洪绘科技" 
                style={{
                  height: 40,
                  marginRight: 16,
                  filter: "brightness(0) invert(1)",
                  paddingLeft: 4,
                }}
              />
            </Title>
            <Paragraph
              style={{
                color: "rgba(255, 255, 255, 0.9)",
                fontSize: 18,
                marginTop: 24,
                maxWidth: "80%",
                lineHeight: 1.8,
              }}
            >
              洪绘科技致力于为开发者提供智能化工具和解决方案。我们专注于AI应用开发和网络工具创新，让开发工作更高效、更智能。
            </Paragraph>

            <Space size={16} style={{ marginTop: 24 }}>
              <Button
                type="default"
                ghost
                size="large"
                style={{
                  borderRadius: 10,
                  padding: "0 28px",
                  height: 46,
                  borderColor: "rgba(255,255,255,0.7)",
                  color: "white",
                  fontWeight: 500,
                }}
                icon={
                  <i
                    className="ri-arrow-right-line"
                    style={{ marginRight: 8 }}
                  />
                }
                onClick={() =>
                  window.open("https://honghui.zhheo.com/", "_blank")
                }
              >
                了解更多
              </Button>
            </Space>
          </div>
        </Card>
      </div>

      <Row gutter={[16, 16]} className="equal-height-cards">
        {/* 开发团队卡片 */}
        <Col xs={24} md={12} className="card-col">
          <div style={{ height: "100%" }}>
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i
                    className="ri-team-line"
                    style={{
                      fontSize: "20px",
                      color: "#1890ff",
                      marginRight: "8px",
                    }}
                  />
                  <span>开发团队</span>
                </div>
              }
              variant="outlined"
              style={{
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                height: "100%",
                overflow: "hidden",
              }}
              styles={{
                header: {
                  borderBottom: "1px solid #f0f0f0",
                  padding: "0 24px",
                },
                body: { padding: "24px" },
              }}
            >
              <Space direction="vertical" size={20} style={{ width: "100%" }}>
                <div
                  onClick={() => window.open("https://blog.zhheo.com/", "_blank")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    background:
                      "linear-gradient(to right, rgba(10, 92, 255, 0.03), rgba(10, 92, 255, 0.07))",
                    padding: "24px",
                    borderRadius: 16,
                    transition: "all 0.3s",
                    cursor: "pointer",
                    border: "1px solid rgba(10, 92, 255, 0.08)",
                  }}
                  className="team-member"
                >
                  <Avatar
                    size={56}
                    src="https://q1.qlogo.cn/g?b=qq&nk=904208603&s=640"
                    style={{
                      marginRight: 20,
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                      border: "4px solid white",
                      flexShrink: 0
                    }}
                  />
                  <div>
                    <Text
                      style={{ 
                        fontSize: 19,
                        fontWeight: 600,
                        color: "#333",
                        display: "block",
                        marginBottom: 8
                      }}
                    >
                      张洪Heo
                    </Text>
                    <Space size={4}>
                      <i
                        className="ri-user-star-line"
                        style={{ color: "#0a5cff", fontSize: 17 }}
                      />
                      <Text style={{ fontSize: 16, color: "#0a5cff" }}>
                        产品设计师
                      </Text>
                    </Space>
                  </div>
                </div>

                <div
                  onClick={() => window.open("https://blog.tianli0.top/", "_blank")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    background:
                      "linear-gradient(to right, rgba(10, 92, 255, 0.03), rgba(10, 92, 255, 0.07))",
                    padding: "24px",
                    borderRadius: 16,
                    transition: "all 0.3s",
                    cursor: "pointer",
                    border: "1px solid rgba(10, 92, 255, 0.08)",
                  }}
                  className="team-member"
                >
                  <Avatar
                    size={56}
                    src="https://q1.qlogo.cn/g?b=qq&nk=507249007&s=640"
                    style={{
                      marginRight: 20,
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                      border: "4px solid white",
                      flexShrink: 0
                    }}
                  />
                  <div>
                    <Text
                      style={{ 
                        fontSize: 19,
                        fontWeight: 600,
                        color: "#333",
                        display: "block",
                        marginBottom: 8
                      }}
                    >
                      Tianli
                    </Text>
                    <Space size={4}>
                      <i
                        className="ri-user-star-line"
                        style={{ color: "#0a5cff", fontSize: 17 }}
                      />
                      <Text style={{ fontSize: 16, color: "#0a5cff" }}>
                        开发工程师
                      </Text>
                    </Space>
                  </div>
                </div>
              </Space>
            </Card>
          </div>
        </Col>

        {/* 技术支持卡片 */}
        <Col xs={24} md={12} className="card-col">
          <div style={{ height: "100%" }}>
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i
                    className="ri-customer-service-2-line"
                    style={{
                      fontSize: "20px",
                      color: "#1890ff",
                      marginRight: "8px",
                    }}
                  />
                  <span>技术支持</span>
                </div>
              }
              variant="outlined"
              style={{
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                height: "100%",
                overflow: "hidden",
              }}
              styles={{
                header: {
                  borderBottom: "1px solid #f0f0f0",
                  padding: "0 24px",
                },
                body: { padding: "24px" },
              }}
            >
              <Space direction="vertical" size={20} style={{ width: "100%" }}>
                <div
                  className="support-item"
                  style={{
                    padding: "24px",
                    borderRadius: 16,
                    background: "linear-gradient(to right, #f9fbff, #f4f8ff)",
                    transition: "all 0.3s",
                    border: "1px solid rgba(10, 92, 255, 0.08)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        width: 56,
                        height: 56,
                        borderRadius: 14,
                        background: "rgba(10, 92, 255, 0.1)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 20,
                        flexShrink: 0
                      }}
                    >
                      <i
                        className="ri-qq-line"
                        style={{ fontSize: 28, color: "#0a5cff" }}
                      />
                    </div>
                    <div>
                      <Text
                        strong
                        style={{
                          fontSize: 18,
                          display: "block",
                          marginBottom: 8,
                          color: "#333",
                        }}
                      >
                        加入QQ用户群
                      </Text>
                      <Link
                        href="https://qm.qq.com/q/oaW8cuWkqk"
                        target="_blank"
                        style={{ fontSize: 16 }}
                      >
                        获取最新产品动态和技术支持
                        <i
                          className="ri-external-link-line"
                          style={{ marginLeft: 8 }}
                        />
                      </Link>
                    </div>
                  </div>
                  <QRCode
                    value="https://qm.qq.com/q/oaW8cuWkqk"
                    size={60}
                    style={{ 
                      margin: 0,
                      padding: "10px",
                      background: "white",
                      borderRadius: 10,
                      boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
                      flexShrink: 0
                    }}
                    color="#0a5cff"
                    errorLevel="M"
                  />
                </div>

                {/* 添加邮箱联系方式 */}
                <div
                  className="support-item"
                  style={{
                    padding: "24px",
                    borderRadius: 16,
                    background: "linear-gradient(to right, #f9fbff, #f4f8ff)",
                    transition: "all 0.3s",
                    border: "1px solid rgba(10, 92, 255, 0.08)",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 56,
                      height: 56,
                      borderRadius: 14,
                      background: "rgba(10, 92, 255, 0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: 20,
                    }}
                  >
                    <i
                      className="ri-mail-send-line"
                      style={{ fontSize: 28, color: "#0a5cff" }}
                    />
                  </div>
                  <div>
                    <Text
                      strong
                      style={{
                        fontSize: 18,
                        display: "block",
                        marginBottom: 8,
                        color: "#333",
                      }}
                    >
                      联系我们
                    </Text>
                    <Link
                      href="mailto:zhheo@qq.com"
                      target="_blank"
                      style={{ fontSize: 16 }}
                    >
                      zhheo@qq.com
                      <i
                        className="ri-external-link-line"
                        style={{ marginLeft: 8 }}
                      />
                    </Link>
                  </div>
                </div>
              </Space>
            </Card>
          </div>
        </Col>

        {/* 相关链接卡片 */}
        <Col xs={24} md={12} className="card-col">
          <div style={{ height: "100%" }}>
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i
                    className="ri-link-m"
                    style={{
                      fontSize: "20px",
                      color: "#1890ff",
                      marginRight: "8px",
                    }}
                  />
                  <span>相关链接</span>
                </div>
              }
              variant="outlined"
              style={{
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                height: "100%",
                overflow: "hidden",
              }}
              styles={{
                header: {
                  borderBottom: "1px solid #f0f0f0",
                  padding: "0 24px",
                },
                body: { padding: "24px" },
              }}
            >
              <Space direction="vertical" size={16} style={{ width: "100%" }}>
                <div
                  className="link-item"
                  style={{
                    padding: "22px",
                    borderRadius: 16,
                    background: "linear-gradient(to right, #f9fbff, #f4f8ff)",
                    transition: "all 0.3s",
                    border: "1px solid rgba(10, 92, 255, 0.08)",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 56,
                      height: 56,
                      borderRadius: 14,
                      background: "rgba(10, 92, 255, 0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: 20,
                    }}
                  >
                    <i
                      className="ri-global-line"
                      style={{ fontSize: 28, color: "#0a5cff" }}
                    />
                  </div>
                  <div>
                    <Text
                      strong
                      style={{
                        fontSize: 18,
                        display: "block",
                        marginBottom: 8,
                        color: "#333",
                      }}
                    >
                      官方网站
                    </Text>
                    <Link
                      href="https://postchat.zhheo.com/"
                      target="_blank"
                      style={{ fontSize: 16 }}
                    >
                      postchat.zhheo.com
                      <i
                        className="ri-external-link-line"
                        style={{ marginLeft: 8 }}
                      />
                    </Link>
                  </div>
                </div>

                <div
                  className="link-item"
                  style={{
                    padding: "22px",
                    borderRadius: 16,
                    background: "linear-gradient(to right, #f9fbff, #f4f8ff)",
                    transition: "all 0.3s",
                    border: "1px solid rgba(10, 92, 255, 0.08)",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 56,
                      height: 56,
                      borderRadius: 14,
                      background: "rgba(10, 92, 255, 0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: 20,
                    }}
                  >
                    <i
                      className="ri-book-2-line"
                      style={{ fontSize: 28, color: "#0a5cff" }}
                    />
                  </div>
                  <div>
                    <Text
                      strong
                      style={{
                        fontSize: 18,
                        display: "block",
                        marginBottom: 8,
                        color: "#333",
                      }}
                    >
                      文档中心
                    </Text>
                    <Link
                      href="https://postchat.zhheo.com/plugin/"
                      target="_blank"
                      style={{ fontSize: 16 }}
                    >
                      插件与接入文档
                      <i
                        className="ri-external-link-line"
                        style={{ marginLeft: 8 }}
                      />
                    </Link>
                  </div>
                </div>
              </Space>
            </Card>
          </div>
        </Col>

        {/* 法律信息卡片 */}
        <Col xs={24} md={12} className="card-col">
          <div style={{ height: "100%" }}>
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i
                    className="ri-file-list-3-line"
                    style={{
                      fontSize: "20px",
                      color: "#1890ff",
                      marginRight: "8px",
                    }}
                  />
                  <span>法律信息</span>
                </div>
              }
              variant="outlined"
              style={{
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                height: "100%",
                overflow: "hidden",
              }}
              styles={{
                header: {
                  borderBottom: "1px solid #f0f0f0",
                  padding: "0 24px",
                },
                body: { padding: "24px" },
              }}
            >
              <Space direction="vertical" size={16} style={{ width: "100%" }}>
                <div
                  className="legal-item"
                  style={{
                    padding: "18px 22px",
                    borderRadius: 16,
                    background: "linear-gradient(to right, #f9fbff, #f4f8ff)",
                    transition: "all 0.3s",
                    border: "1px solid rgba(10, 92, 255, 0.08)",
                  }}
                >
                  <Text
                    strong
                    style={{
                      fontSize: 18,
                      display: "block",
                      marginBottom: 8,
                      color: "#333",
                    }}
                  >
                    <i
                      className="ri-file-text-line"
                      style={{ marginRight: 10, color: "#0a5cff" }}
                    />
                    用户协议
                  </Text>
                  <Link
                    href="https://postchat.zhheo.com/infouser.html"
                    target="_blank"
                    style={{ fontSize: 16 }}
                  >
                    查看《用户协议》详情
                    <i
                      className="ri-arrow-right-s-line"
                      style={{ marginLeft: 6 }}
                    />
                  </Link>
                </div>

                <div
                  className="legal-item"
                  style={{
                    padding: "18px 22px",
                    borderRadius: 16,
                    background: "linear-gradient(to right, #f9fbff, #f4f8ff)",
                    transition: "all 0.3s",
                    border: "1px solid rgba(10, 92, 255, 0.08)",
                  }}
                >
                  <Text
                    strong
                    style={{
                      fontSize: 18,
                      display: "block",
                      marginBottom: 8,
                      color: "#333",
                    }}
                  >
                    <i
                      className="ri-vip-crown-2-line"
                      style={{ marginRight: 10, color: "#0a5cff" }}
                    />
                    会员服务协议
                  </Text>
                  <Link
                    href="https://postchat.zhheo.com/infovip.html"
                    target="_blank"
                    style={{ fontSize: 16 }}
                  >
                    查看《会员服务协议》详情
                    <i
                      className="ri-arrow-right-s-line"
                      style={{ marginLeft: 6 }}
                    />
                  </Link>
                </div>

                <div
                  className="legal-item"
                  style={{
                    padding: "18px 22px",
                    borderRadius: 16,
                    background: "linear-gradient(to right, #f9fbff, #f4f8ff)",
                    transition: "all 0.3s",
                    border: "1px solid rgba(10, 92, 255, 0.08)",
                  }}
                >
                  <Text
                    strong
                    style={{
                      fontSize: 18,
                      display: "block",
                      marginBottom: 8,
                      color: "#333",
                    }}
                  >
                    <i
                      className="ri-copyright-line"
                      style={{ marginRight: 10, color: "#0a5cff" }}
                    />
                    版权声明
                  </Text>
                  <Text style={{ fontSize: 16 }}>
                    © 2023 - {new Date().getFullYear()} Heo & Tianli. All Rights
                    Reserved.
                  </Text>
                </div>
              </Space>
            </Card>
          </div>
        </Col>
      </Row>
      {/* 添加全局样式 */}
      <style>
        {`
          .link-item:hover, .legal-item:hover, .support-item:hover, .team-member:hover {
            background: linear-gradient(to right, #f0f7ff, #e8f1ff) !important;
          }
          
          .ant-card-head-title {
            font-weight: 600 !important;
          }
          
          .ant-btn-primary {
            box-shadow: 0 6px 16px rgba(10, 92, 255, 0.25);
          }
          
          .card-col {
            margin-bottom: 0;
          }
          
          .ant-card {
            transition: all 0.3s ease;
          }
          
          .shadow-card {
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
            transition: all 0.3s ease;
          }
        `}
      </style>
    </div>
  );
};

export default About;
